import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Slide, Grow, Zoom, AppBar, Toolbar } from '@material-ui/core';

import * as go from 'gojs';
import { ReactDiagram } from 'gojs-react';

import './Structure.css';

import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

function initDiagram() {
    const $ = go.GraphObject.make;
    // set your license key here before creating the diagram: go.Diagram.licenseKey = "...";
    const diagram =
        $(go.Diagram,
            {
                'undoManager.isEnabled': false,  // must be set to allow for model change listening
                // 'undoManager.maxHistoryLength': 0,  // uncomment disable undo/redo functionality
                'clickCreatingTool.archetypeNodeData': { text: 'new node', color: 'lightblue' },
                model: $(go.GraphLinksModel,
                    {
                        linkKeyProperty: 'key'  // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
                    })
            });

    // define a simple Node template
    diagram.nodeTemplate =
        $(go.Node, 'Auto',  // the Shape will go around the TextBlock
            new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
            $(go.Shape, 'RoundedRectangle',
                { name: 'SHAPE', fill: 'white', strokeWidth: 0 },
                // Shape.fill is bound to Node.data.color
                new go.Binding('fill', 'color')),
            $(go.TextBlock,
                { margin: 8, editable: true },  // some room around the text
                new go.Binding('text').makeTwoWay()
            )
        );

    return diagram;
}

/**
 * This function handles any changes to the GoJS model.
 * It is here that you would make any updates to your React state, which is dicussed below.
 */
function handleModelChange(changes) {
    alert('GoJS model changed!');
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    appBar: {
        position: 'relative',
        background: theme.palette.info.main
    },
});

const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default function DialogGojs({ setDialogOpen, onDialogClose }) {
    const classes = useStyles();
    const [open, setOpen] = useState(setDialogOpen);
    const [fullScreen, setFullScreen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        onDialogClose();
    };

    useEffect(() => {
        setOpen(setDialogOpen);
    }, [setDialogOpen])

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            TransitionComponent={Transition}
            fullWidth={true}
            maxWidth="lg"
            fullScreen={fullScreen}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Estructura Organizativa del Centro Meteorológico Provincial
                    </DialogTitle>
                </Toolbar>
            </AppBar>

            <DialogContent dividers>
                <ReactDiagram
                    initDiagram={initDiagram}
                    divClassName='diagram-component'
                    nodeDataArray={[
                        { key: 0, text: 'Dirección', color: 'lightblue', loc: '0 0' },
                        { key: 1, text: 'Sub-dirección Técnica', color: 'orange', loc: '250 100' },
                        { key: 2, text: 'Sub-dirección Administrativa', color: 'lightgreen', loc: '-250 100' },
                        { key: 3, text: 'Grupo Científico', color: 'pink', loc: '100 200' },
                        { key: 4, text: 'Grupo Pronósticos', color: 'pink', loc: '250 200' },
                        { key: 5, text: 'Grupo Instrumentos', color: 'pink', loc: '400 200' },
                        { key: 6, text: 'Grupo Informática', color: 'pink', loc: '550 200' },
                        { key: 7, text: 'Laboratorio', color: 'pink', loc: '50 250' },
                        { key: 8, text: 'Est Contre', color: 'pink', loc: '200 25' },
                        { key: 9, text: 'Est Univ', color: 'pink', loc: '300 25' },
                        { key: 10, text: 'Est GP', color: 'pink', loc: '400 25' },
                        { key: 11, text: 'Est RGP', color: 'pink', loc: '500 25' },
                        { key: 12, text: 'Dep Inf', color: 'pink', loc: '600 250' },
                        { key: 13, text: 'Grupo Eco', color: '#90ee9080', loc: '-300 200' },
                        { key: 14, text: 'Grupo RH', color: '#90ee9080', loc: '-200 200' },
                        { key: 15, text: 'Brigada JC', color: '#90ee9080', loc: '-100 200' }
                    ]}
                    linkDataArray={[
                        { key: -1, from: 0, to: 1 },
                        { key: -2, from: 0, to: 2 },
                        { key: -3, from: 1, to: 3 },
                        { key: -4, from: 1, to: 4 },
                        { key: -5, from: 1, to: 5 },
                        { key: -6, from: 1, to: 6 },
                        { key: -7, from: 3, to: 7 },
                        { key: -8, from: 1, to: 8 },
                        { key: -9, from: 1, to: 9 },
                        { key: -10, from: 1, to: 10 },
                        { key: -11, from: 1, to: 11 },
                        { key: -12, from: 6, to: 12 },
                        { key: -13, from: 2, to: 13 },
                        { key: -14, from: 2, to: 14 },
                        { key: -15, from: 2, to: 15 }
                    ]}
                    onModelChange={handleModelChange}
                />
            </DialogContent>
            <DialogActions>
                {
                    fullScreen &&
                    <IconButton aria-label="" onClick={() => setFullScreen(false)}>
                        <FullscreenExitIcon />
                    </IconButton>
                }
                {
                    !fullScreen &&
                    <IconButton aria-label="" onClick={() => setFullScreen(true)}>
                        <FullscreenIcon />
                    </IconButton>
                }
            </DialogActions>
        </Dialog>
    );
}
